import { createAction } from '../utils/store';

export const completeEnrollment = createAction('COMPLETE_ENROLLMENT');
